import { buildVerificationCommand } from './verificationCommand';
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import messages from './locales.json';
import release from './release.json';
import './download.css';
export const languages = [['en','English'],['es','Español'],['pt-PT','Português'],['ja','日本語'],['ko','한국어'],['zh-CN','简体中文']];
export function detectLanguage(saved, browserLanguage) {
 if (messages[saved]) return saved;
 const prefix = String(browserLanguage || '').toLowerCase().split('-')[0];
 return ({en:'en',es:'es',pt:'pt-PT',ja:'ja',ko:'ko',zh:'zh-CN'})[prefix] || 'en';
}
function initialLanguage() {
 let saved; try { saved=localStorage.getItem('startax.download.language'); } catch {}
 return detectLanguage(saved, navigator.language);
}
export default function DesktopDownload() {
 const [open,setOpen]=useState(false);
 const [language,setLanguage]=useState(initialLanguage);
 const [notice,setNotice]=useState(null);
 const dialog=useRef(null), trigger=useRef(null);
 const t=messages[language];
 useEffect(()=>{
  if(!open) return;
  const element=dialog.current;
  const opener=trigger.current;
  element.showModal();
  return ()=>{element.close();opener?.focus();};
 },[open]);
 function changeLanguage(event) {
  setLanguage(event.target.value);setNotice(null);
  try { localStorage.setItem('startax.download.language',event.target.value); } catch {}
 }
 async function copy(value, target) {
  setNotice(null);
  try { await navigator.clipboard.writeText(value);setNotice({target, message:t.copied}); }
  catch { setNotice({target, message:t.copyFailed}); }
 }
 const commands=buildVerificationCommand(release,t);
 return <>
  <button ref={trigger} type="button" className="slotDesktopDownload" onPointerDown={event=>event.stopPropagation()} onClick={()=>{setNotice(null);setOpen(true);}} aria-haspopup="dialog">
   <span className="slotDesktopDownloadIcon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5"/></svg></span>
   <span className="slotDesktopDownloadTitle"><span>DOWNLOAD</span><span>DESKTOP <span className="slotDesktopDownloadDapp">dAPP</span></span></span>
  </button>
  {open && createPortal(<dialog ref={dialog} className="st-download-dialog" lang={language} aria-labelledby="st-download-title" onCancel={()=>setOpen(false)} onClose={()=>setOpen(false)}>
   <button className="st-close" type="button" onClick={()=>setOpen(false)} aria-label={t.close}>×</button>
   <div className="st-download-scroll">
   <div className="st-download-top"><div><h2 id="st-download-title" className="st-download-brand"><img src={`${process.env.PUBLIC_URL}/logo512.png`} alt="" aria-hidden="true" width="42" height="42" /><span>StarTax <span className="st-desktop-name">Desktop</span></span></h2><p className="st-platform">Windows · v{release.version} · x64 <span>SELF-SIGNED</span></p></div><label>{t.language}<select value={language} onChange={changeLanguage}>{languages.map(([value,label])=><option key={value} value={value}>{label}</option>)}</select></label></div>
   <p>{t.intro}</p>
   <section className="st-windows"><h3>{t.windowsTitle}</h3><p>{t.windowsText}</p><p>{t.continueText}</p></section>
   <a className="st-install" href={`/downloads/${release.filename}`} download={release.filename}>{t.download}<span aria-hidden="true">↓</span></a>
   <details className="st-verification"><summary>{t.verifyTitle}</summary>
    <ol className="st-verify-steps"><li>{t.stepDownload}</li><li>{t.stepPowerShell}</li><li>{t.stepPaste}</li></ol>
    <span className="st-copy-action"><button className="st-copy-command" type="button" onClick={()=>copy(commands+"\r\n",'commands')}>{t.copyCommand}</button><span className="st-copy-notice" role="status">{notice?.target==='commands' ? notice.message : ''}</span></span>
    <pre tabIndex="0" aria-label={t.copyCommand}>{commands}</pre>
    <p>{t.signatureHelp}</p>
    <p>{t.verifyIntro}</p>
    {[[t.fileHash,release.sha256],[t.certHash,release.certificateSha256]].map(([label,value])=><div className="st-hash" key={label}><div><strong>{label}</strong><span className="st-copy-action"><button type="button" onClick={()=>copy(value,label)}>{t.copy}</button><span className="st-copy-notice" role="status">{notice?.target===label ? notice.message : ''}</span></span></div><code>{value}</code></div>)}
    <nav className="st-verification-links"><a href={`/downloads/${release.certificate}`} download>{t.certificate}</a><a href={`/downloads/${release.filename}.sha256`} download>{t.checksum}</a></nav>

   <footer><strong>{t.identity}</strong><p>{t.independent}</p></footer>
   </details>
   </div>
  </dialog>,document.body)}
 </>;
}
